module.exports = __webpack_public_path__ + "img/kongzi big (10).b3321c61.jpg";